import React, { useEffect } from 'react';
import { setPageMeta } from '../utils/seo';

const Privacy = () => {
  useEffect(() => {
    setPageMeta({
      title: 'Política de Privacidade',
      description: 'Política de privacidade da Diamond Cars. Saiba como tratamos os seus dados pessoais.',
      path: '/privacidade'
    });
  }, []);

  const lastUpdated = '14 de março de 2026';

  return (
    <div className="bg-gray-50 min-h-screen py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-xl shadow-sm p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Política de Privacidade</h1>
          <p className="text-sm text-gray-500 mb-10">Última atualização: {lastUpdated}</p>

          <div className="space-y-8 text-gray-700 leading-relaxed">

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">1. Responsável pelo Tratamento</h2>
              <p>
                A <strong>Diamond Cars</strong>, com sede em R. Monsenhor Miguel de Oliveira 1272, 3880-796 Ovar,
                contactável através do email <a href="mailto:diamond.cars.rg@gmail.com" className="text-blue-600 hover:underline">diamond.cars.rg@gmail.com</a> ou
                do telefone <a href="tel:+351911504560" className="text-blue-600 hover:underline">+351 911 504 560</a>, é a responsável
                pelo tratamento dos dados pessoais recolhidos neste website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">2. Dados Recolhidos</h2>
              <p className="mb-3">Recolhemos os seguintes dados pessoais quando preenche os nossos formulários de contacto:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-600">
                <li>Nome completo</li>
                <li>Endereço de email</li>
                <li>Número de telefone</li>
                <li>Mensagem ou pedido de informação</li>
              </ul>
              <p className="mt-3">
                Também podemos recolher automaticamente dados técnicos como o endereço IP e informações do browser,
                para fins de segurança e melhoria do serviço.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">3. Finalidade do Tratamento</h2>
              <p className="mb-3">Os seus dados são utilizados exclusivamente para:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-600">
                <li>Responder aos seus pedidos de informação ou contacto</li>
                <li>Enviar informações sobre viaturas do seu interesse</li>
                <li>Melhorar os nossos serviços e a experiência no website</li>
                <li>Cumprimento de obrigações legais</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">4. Base Legal</h2>
              <p>
                O tratamento dos seus dados baseia-se no seu consentimento, dado no momento do preenchimento
                dos formulários, e no interesse legítimo da Diamond Cars em responder aos seus pedidos
                (artigo 6.º, n.º 1, alíneas a) e f) do RGPD).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">5. Partilha de Dados</h2>
              <p>
                Os seus dados pessoais não são vendidos, alugados nem partilhados com terceiros para fins
                comerciais. Poderão ser partilhados com prestadores de serviços técnicos (como serviços de
                email e alojamento) estritamente necessários para o funcionamento do website, que operam
                sob obrigações de confidencialidade.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">6. Conservação dos Dados</h2>
              <p>
                Os seus dados são conservados pelo período necessário para responder ao seu pedido e,
                no máximo, por 2 anos, salvo obrigação legal que imponha prazo diferente.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">7. Os Seus Direitos</h2>
              <p className="mb-3">Nos termos do RGPD, tem os seguintes direitos:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-600">
                <li><strong>Acesso</strong> — consultar os dados que temos sobre si</li>
                <li><strong>Retificação</strong> — corrigir dados inexatos ou incompletos</li>
                <li><strong>Eliminação</strong> — solicitar o apagamento dos seus dados</li>
                <li><strong>Oposição</strong> — opor-se ao tratamento em certas circunstâncias</li>
                <li><strong>Portabilidade</strong> — receber os seus dados em formato estruturado</li>
                <li><strong>Limitação</strong> — restringir o tratamento dos seus dados</li>
              </ul>
              <p className="mt-3">
                Para exercer qualquer um destes direitos, contacte-nos por email para{' '}
                <a href="mailto:diamond.cars.rg@gmail.com" className="text-blue-600 hover:underline">
                  diamond.cars.rg@gmail.com
                </a>.
                Tem ainda o direito de apresentar reclamação à autoridade de controlo portuguesa,
                a <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">CNPD</a>.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">8. Segurança</h2>
              <p>
                Adotamos medidas técnicas e organizacionais adequadas para proteger os seus dados pessoais
                contra acesso não autorizado, perda ou destruição acidental.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">9. Cookies</h2>
              <p>
                Este website pode utilizar cookies essenciais para o seu funcionamento. Não utilizamos
                cookies de rastreamento ou publicidade de terceiros.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">10. Alterações a esta Política</h2>
              <p>
                Reservamo-nos o direito de atualizar esta política sempre que necessário. A data de
                última atualização será sempre indicada no topo desta página.
              </p>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
